export default "__VITE_ASSET__d0b12164__"